import mapElementToValue from "../mapElementToValue.es6";
import CardSound from "../cardSound.es6";
import stopEvent from "../stopEvent.es6";

export default class PlayAudio {
    /**
     *
     * @param {jQuery} jqButton
     * @param {boolean} [autoPlay]
     * @param {jQuery} [side]
     */
    static initSingleSide(jqButton, autoPlay, side) {
        const singleSide = mapElementToValue('single-side', el => {
            const button = $(el);
            if (!side) {
                side = button.closest('.fl-memo-card').find('.fl-memo-card__side');
            }
            return CardSound.singleSideButton(button, side);
        });

        jqButton.click((e) => {
            singleSide.get(e.currentTarget).toggle();
            return stopEvent(e);
        });

        if (!!autoPlay) {
            jqButton.click();
        }
    }

    static initMultiSide(jqButton, autoPlay) {
        const multiSide = mapElementToValue('multi-side', el => {
            const button = $(el);
            const sides = button.closest('.fl-memo-card').find('.fl-memo-card__side');
            return CardSound.multiSideButton(button,
                sides.get(0),
                sides.get(1));
        });

        jqButton.click((e) => {
            multiSide.get(e.currentTarget).toggle();
            return stopEvent(e);
        });

        if (!!autoPlay) {
            jqButton.click();
        }
    }
}